module.exports = __webpack_public_path__ + "img/img-spadegaming.146a9cb7.png";